export const parseJwt = (token) => {
  if (!token) {
    return null;
  }
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return null;
    }
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

const normalizeRole = (value) => {
  if (!value) {
    return null;
  }
  const text = String(value).toLowerCase();
  if (text.includes('store')) {
    return 'store';
  }
  if (text.includes('user') || text.includes('customer') || text.includes('shopper')) {
    return 'user';
  }
  return null;
};

export const resolveRole = (token, fallbackRole = 'user') => {
  const claims = parseJwt(token);
  const candidates = [
    claims?.role,
    claims?.principalType,
    claims?.userType,
    claims?.loginTarget,
    claims?.accountType,
    claims?.type,
    claims?.aud
  ];
  const match = candidates.map(normalizeRole).find(Boolean);
  return match || fallbackRole;
};
